import { sortBy } from '@savgroup-front-common/core/helpers';
import { SearchOrderDetailsDto } from '@savgroup-front-common/types';

export const adaptSearchOrderDetails = (
  order?: SearchOrderDetailsDto,
): SearchOrderDetailsDto | undefined => {
  if (!order) {
    return order;
  }

  return {
    ...order,
    products: order.products.sort(sortBy({ fieldName: 'orderLineReference' })),
  };
};
